import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { DateInput } from "@air/primitive-date-input";
export const DateRangeInput = (param)=>{
    let { size, startDate, endDate, onEndDateChange, onStartDateChange } = param;
    return /*#__PURE__*/ _jsxs("div", {
        className: "flex items-center",
        children: [
            /*#__PURE__*/ _jsx(DateInput, {
                size: size,
                selected: startDate,
                startDate: startDate,
                endDate: endDate,
                maxDate: endDate !== null && endDate !== void 0 ? endDate : undefined,
                selectsRange: true,
                name: "startDate",
                onChange: onStartDateChange
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "mx-2.5 h-0.5 w-3 rounded-sm bg-grey-9"
            }),
            /*#__PURE__*/ _jsx(DateInput, {
                size: size,
                selected: endDate,
                startDate: startDate,
                endDate: endDate,
                minDate: startDate !== null && startDate !== void 0 ? startDate : undefined,
                selectsEnd: true,
                name: "endDate",
                onChange: onEndDateChange
            })
        ]
    });
};
